import $ from "jquery";

const {Client, Server, Message} = (inElectron()) ? require('node-osc') : false;

export class SeveCommunication {

  // Constructor
  constructor(host = '127.0.0.1', clientPort = 3333, serverPort = 3334, addresses) {
    this.runningFromBrowser = null;
    this.client = null;

    const searchParams = new URLSearchParams(window.location.search);
    const instanceId = searchParams.has('instanceId') ? searchParams.get('instanceId') : "1";
    this.address = addresses[this.getAppName()][instanceId];

    this.dispatcher = $({});
    this.init(host, clientPort, serverPort).then(() => {
      if (!this.runningFromBrowser) console.log(`OSC communication for Seve initiated on ${host}:${clientPort} and ${serverPort}.`)
    });
  }

  // Load settings JSON (with promise)
  async init(host, clientPort, serverPort) {

    if (Client !== false && typeof Client != "undefined") {
      this.runningFromBrowser = false;
      this.client = new Client(host, clientPort);
      this.server = new Server(serverPort, host);

      // Listen for incoming OSC messages
      this.server.on('message', (msg, rinfo) => {
        // console.log(`Message: ${msg}\nReceived from: ${rinfo.address}:${rinfo.port}`);
        if (msg.length >= 2 && msg[0] === this.address && parseInt(msg[1]) === 4) {
          // Button is pressed, dispatch Event
          const event = $.Event('buttonPressed');
          this.dispatcher.trigger(event);
        }
      });

    } else {
      this.runningFromBrowser = true;
      $(document).on('keydown', (e) => {
        if (e.keyCode === 32 || e.key === " ") {
          const event = $.Event('buttonPressed');
          this.dispatcher.trigger(event);
        }
      })
    }
  };

  async sendMessage(message) {

    if (!this.runningFromBrowser) {
      const oscMessage = new Message(this.address);
      oscMessage.append(message);  // Append a string

      // Send the message with a callback
      this.client.send(oscMessage, (err) => {
        if (err) {
          console.error(new Error(err));
        }
        console.log(`Message sent to Seve: ${this.address} ${message}`);
      });

    } else {
      console.info(`Message would be send to Seve in Electron app: ${this.address} ${message}`);
    }
  }

  getAppName() {
    if (app instanceof EtoilesApp) return "etoiles";
    else if (app instanceof CameraApp) return "camera";
    else if (app instanceof CerveauApp) return "cerveau";
    else if (app instanceof BiodiversiteApp) return "biodiversite";
  }

  close() {
    this.client.close();
  }

  on() {
    this.dispatcher.on.apply(this.dispatcher, arguments)
  }

  off() {
    this.dispatcher.off.apply(this.dispatcher, arguments)
  }

  one() {
    this.dispatcher.one.apply(this.dispatcher, arguments)
  }

}
